import { Injectable } from '@angular/core';
import { Konfiguration } from 'lion-api';

@Injectable({
  providedIn: 'root'
})
export class KonfigurationenUtilService {
  getKonfigurationValue(key: string | undefined, konfigurationen: Konfiguration[]): string {
    if (!key) {
      return '';
    }

    const value = konfigurationen!.filter((k) => k.key == key)[0]?.value;

    if (value) {
      return value;
    }
    return '';
  }

  getKonfigurationValueAsDate(key: string, konfigurationen: Konfiguration[]): Date {
    return new Date(Date.parse(this.getKonfigurationValue(key, konfigurationen)));
  }

  getKonfigurationValueAsBoolean(key: string, konfigurationen: Konfiguration[]): boolean {
    const configValue = this.getKonfigurationValue(key, konfigurationen).toLowerCase();
    //Falls boolesche Werte als '1' oder '0' in der Datenbank abgelegt sind
    if (configValue === 'true' || configValue === 'false') {
      return 'true' === configValue;
    } else if (configValue === '0' || configValue === '1') {
      return '1' === configValue;
    }
    return false;
  }
}
